/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderShortAccess } from './order_short_access'
import type { OrderShortCargoInfo } from './order_short_cargo_info'
import type { OrderShortPoint } from './order_short_point'
/**
 * Данные заявки
 */
export type OrderShortItem = {
  /**
   * Идентификатор заявки
   */
  id: string
  /**
   * Номер заявки
   */
  serialId: number
  /**
   * Трек-номер заявки
   */
  barcode?: string
  /**
   * Статус заявки
   */
  status: OrderShortItem.Status
  /**
   * Статус оплаты заявки
   */
  paymentStatus: OrderShortItem.paymentStatus
  /**
   * Плановая дата передачи груза
   */
  departureDate: string
  /**
   * Информация об отправителе и пункте погрузки
   */
  departure: OrderShortPoint
  /**
   * Информация о получателе и пункте выгрузки
   */
  destination: OrderShortPoint
  /**
   * Информация о грузе
   */
  cargoInfo: OrderShortCargoInfo
  /**
   * Цена (в рублях)
   */
  totalPrice: string
  /**
   * Принят ли груз у клиента (внесены фактические ВГХ, произведен окончательный расчет стоимости)?
   */
  isCargoAccepted: boolean
  /**
   * Права доступа
   */
  access: OrderShortAccess
}
export namespace OrderShortItem {
  /**
   * Статус заявки
   */
  export enum Status {
    NEW = 'new',
    DEPARTURE_COURIER_ASSIGNED = 'departureCourierAssigned',
    DEPARTURE_COURIER = 'departureCourier',
    DEPARTURE_TERMINAL = 'departureTerminal',
    TRANSIT = 'transit',
    DESTINATION_TERMINAL = 'destinationTerminal',
    DESTINATION_COURIER_ASSIGNED = 'destinationCourierAssigned',
    DESTINATION_COURIER = 'destinationCourier',
    DELIVERED = 'delivered',
    CANCEL = 'cancel'
  }
  /**
   * Статус оплаты заявки
   */
  export enum paymentStatus {
    NO = 'no',
    PART = 'part',
    FULL = 'full',
    OVER = 'over'
  }
}
